import React from 'react'
import { Link } from "react-router-dom";

const EVChargingSolution = () => {
  return (
    <>


      <div className="site-breadcrumb" style={{ background: 'url(assets/yog/0101.webp)' }}>
        <div className="container">
          <h2 className="breadcrumb-title">EV Charging Solution</h2>
          <ul className="breadcrumb-menu">
            <li><Link to="/">Home</Link></li>
            <li className="active"><b>EV Charging Solution</b></li>
          </ul>
        </div>
      </div>
      <div className="service-single py-120" style={{ marginTop: "-80px" }}>
        <div className="container">
          <div className="service-single-wrap">
            <div className="row">

              <div className="col-xl-4 col-lg-4">
                <div className="service-sidebar">
                  <div className="widget">
                    <h4 className="title">All Services</h4>
                    <div className="category">
                      <Link to="/EV-charging-solution"><i className="far fa-angle-double-right" /><b>EV Charging Solution</b></Link>
                      <Link to="/energy-efficient-building"><i className="far fa-angle-double-right" /><b>Energy Efficient Building</b></Link>
                      <Link to="/hybrid-solar-power-plant"><i className="far fa-angle-double-right" /><b>Hybrid Solar Power Plant</b></Link>
                      <Link to="/on-grid-off-grid-solar"><i className="far fa-angle-double-right" /><b>On-Grid & Off-Grid Solar</b></Link>
                      <Link to="/solar-water-heater-solution"><i className="far fa-angle-double-right" /><b>Solar Water Heater Solution</b></Link>
                      <Link to="/solar-water-pump-solution"><i className="far fa-angle-double-right" /><b>Solar Water Pump Solution</b></Link>
                      <Link to="/solar-electrical-installation"><i className="far fa-angle-double-right" /><b>Solar & Electrical Installation</b></Link>
                    </div>
                  </div>
                  {/* <div className="widget">
                    <h4 className="title">Download</h4>
                    <div className="service-download">
                      <a to="#"><i className="far fa-file-pdf" /> Download Brochure</a>
                      <a to="#"><i className="far fa-file-alt" /> Download Application</a>
                    </div>
                  </div> */}
                </div>
              </div>
              <div className="col-xl-8 col-lg-8">
                <div className="service-details">
                  <div className="mb-30">
                    <img src="assets/yog/EV.webp" alt="thumb" />
                  </div>
                  <div className="content">
                    <h3 className="mb-20">Powering the Future with Yogesh Solar Energy</h3>
                    <p className="mb-20" style={{ textAlign: "justify" }}>
                      As the world shifts towards clean and sustainable mobility, Yogesh Solar Energy brings you advanced and reliable EV Charging Solutions designed for homes, businesses, and commercial spaces.
                    </p>
                    <p className="mb-20" style={{ textAlign: "justify" }}>
                      We provide end-to-end electric vehicle (EV) charging infrastructure to help you embrace the future of transportation with ease, efficiency, and sustainability.
                    </p>
                    {/* <div className="row">
                      <div className="col-md-6 mb-20">
                        <img src="assets/img/service/01.jpg" alt />
                      </div>
                      <div className="col-md-6 mb-20">
                        <img src="assets/img/service/02.jpg" alt />
                      </div>
                    </div> */}
                    <div className="my-4">
                      <div className="mb-3">
                        <h3 className="mb-3">Our EV Charging Services</h3>
                      </div>
                      <ul className="list">
                        <li><i className="far fa-check-double" />Residential EV Charging:- Charge your electric vehicle conveniently at home with our safe and efficient charging systems.

                          Easy installation
                          Smart charging features
                          Compatible with all EV models</li>
                        <li><i className="far fa-check-double" />Commercial EV Charging:- Upgrade your business by offering EV charging facilities to your customers and employees.

                          Ideal for offices, malls, hotels & parking spaces
                          Scalable solutions
                          Boosts customer engagement & brand value</li>
                        <li><i className="far fa-check-double" />Fast Charging Stations:- We install high-speed charging stations for quick and efficient charging.

                          Reduced charging time
                          High-performance equipment
                          Suitable for highways & public spaces
                        </li>
                        <li><i className="far fa-check-double" />Installation & Maintenance:- Our expert team ensures seamless installation and long-term support.

                          Site inspection & consultation
                          Professional setup
                          Regular maintenance & support</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



    </>
  )
}

export default EVChargingSolution